<template>
  <!-- Share your knowledge -->
  <section class="share-knowledge-five">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-12" data-aos="fade-down">
          <div class="section-five-sub">
            <div class="header-five-title mb-0">
              <h2>Want to share your knowledge? Join us a Mentor</h2>
            </div>
            <div class="career-five-content">
              <p>
                High-definition video is video of higher resolution and quality than
                standard-definition.
              </p>
            </div>
            <ul class="list-unstyled heading-color mb-4">
              <li class="d-flex mb-3">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Access Your
                Class anywhere
              </li>
              <li class="d-flex mb-3">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Flexible
                Course Plan
              </li>
              <li class="d-flex mb-3 aos-init aos-animate">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Quality
                Assurance
              </li>
              <li class="d-flex mb-3 aos-init aos-animate">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Cost
                Effectiveness
              </li>
              <li class="d-flex mb-3 aos-init aos-animate">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>The Most
                World Class Instructors
              </li>
            </ul>

            <router-link to="/course/course-list" class="btn btn-primary"
              >Start Teaching Today</router-link
            >
          </div>
        </div>
        <div class="col-lg-6 col-sm-12" data-aos="fade-down">
          <div class="joing-count-five text-center">
            <div class="joing-count-image">
              <img src="@/assets/img/feature/feature-7.png" alt="Img" />
              <img
                src="@/assets/img/shapes/dot-2.svg"
                alt="img"
                class="joing-count-img1"
              />
              <img
                src="@/assets/img/shapes/half-circle.svg"
                alt="img"
                class="joing-count-img2"
              />
            </div>
            <div class="joing-count-five-one course-count">
              <h3 class="joing-count-number">
                <span class="counterUp">5,5</span>K<span>+</span>
              </h3>
              <p class="joing-count-text">Courses</p>
            </div>
            <div class="joing-count-five-two course-count">
              <h3 class="joing-count-number"><span class="counterUp">50</span>K</h3>
              <p class="joing-count-text">Appreciations</p>
            </div>
            <div class="joing-count-five-three course-count">
              <h3 class="joing-count-number"><span class="counterUp">100</span></h3>
              <p class="joing-count-text">Countries</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Share your knowledge -->
</template>
